import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
export var REPORT_DATE_RANGE_OPTIONS = [
    {
        value: "custom",
        label: "กำหนดเอง"
    },
    {
        value: "today",
        label: "วันนี้"
    },
    {
        value: "days_7",
        label: "7 วันย้อนหลัง"
    },
    {
        value: "days_15",
        label: "15 วันย้อนหลัง"
    },
    {
        value: "months_1",
        label: "เดือนนี้"
    },
    {
        value: "previous_month",
        label: "เดือนที่ผ่านมา"
    },
    {
        value: "months_3",
        label: "3 เดือนย้อนหลัง"
    },
    {
        value: "months_6",
        label: "6 เดือนย้อนหลัง"
    },
    {
        value: "months_9",
        label: "9 เดือนย้อนหลัง"
    },
    {
        value: "months_12",
        label: "12 เดือนย้อนหลัง"
    }
];
export var getReportDateRange = function(preset) {
    var referenceDate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    if (!preset || preset === "custom") return null;
    if (preset === "previous_month") {
        var previousMonth = moment(referenceDate).subtract(1, "month");
        return {
            startDate: previousMonth.clone().startOf("month").toDate(),
            endDate: previousMonth.clone().endOf("month").toDate()
        };
    }
    var endDate = moment(referenceDate).startOf("day");
    var startDate = endDate.clone();
    if (preset.startsWith("days_")) {
        var dayCount = Number(preset.replace("days_", ""));
        startDate.subtract(Math.max(dayCount - 1, 0), "days");
    } else if (preset.startsWith("months_")) {
        var monthCount = Number(preset.replace("months_", ""));
        startDate.startOf("month").subtract(Math.max(monthCount - 1, 0), "months");
    }
    return {
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
    };
};
var getSelectStyles = function(controlHeight) {
    var height = typeof controlHeight === "number" ? "".concat(controlHeight, "px") : controlHeight;
    return _object_spread({
        menuPortal: function(base) {
            return _object_spread_props(_object_spread({}, base), {
                zIndex: 9999
            });
        },
        menu: function(base) {
            return _object_spread_props(_object_spread({}, base), {
                zIndex: 9999
            });
        }
    }, height && {
        control: function(base) {
            return _object_spread_props(_object_spread({}, base), {
                minHeight: height,
                height: height
            });
        }
    });
};
export default function ReportDateRangeSelect(param) {
    var value = param.value, onChange = param.onChange, _param_groupClassName = param.groupClassName, groupClassName = _param_groupClassName === void 0 ? "mb-2 form-st-3" : _param_groupClassName, classNamePrefix = param.classNamePrefix, controlHeight = param.controlHeight;
    return /*#__PURE__*/ _jsxs(Form.Group, {
        className: groupClassName,
        children: [
            /*#__PURE__*/ _jsx(Form.Label, {
                className: "mb-1",
                children: "ช่วงวันที่"
            }),
            /*#__PURE__*/ _jsx(Select, {
                className: "w-100 select-st-3",
                classNamePrefix: classNamePrefix,
                options: REPORT_DATE_RANGE_OPTIONS,
                value: REPORT_DATE_RANGE_OPTIONS.find(function(option) {
                    return option.value === value;
                }) || REPORT_DATE_RANGE_OPTIONS[0],
                onChange: function(option) {
                    return onChange((option === null || option === void 0 ? void 0 : option.value) || "custom");
                },
                isClearable: false,
                menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
                menuPosition: "fixed",
                styles: getSelectStyles(controlHeight)
            })
        ]
    });
}
